<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      :add-text="handlePermission('goodsPrimaryKeyAdd') ? '编辑商品主键' : ''"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      @addNew="addNew">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品编码:</label>
            <lk-input class="item" v-model.trim="query.queryCode" clearable></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch(false, pollingData)">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>

    <operate-log v-model="showLog" :logList="logData"/>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import toolsService from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import OperateLog from '../../components/operateLog';

// 接口信息
export default {
  name: 'GoodsPrimaryKey',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    OperateLog,
  },
  data() {
    return {
      query: {
        queryCode: '', // 商品名称
      },
      showLog: false,
		  timer: null,
      statusMap: new Map([
        [1, '成功'],
        [2, '失败'],
        [3, '修改中...'],
      ]),
      columns: [
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
		    {
		    	title: '修改进度',
          key: 'status',
          minWidth: 116,
			    render: (h, { row }) => h('span', {
			    	class: {
			    		error: row.status === 2,
            },
          }, this.statusMap.get(row.status)),
        },
        { title: '商品类型', key: 'goodsTypeStr', minWidth: 116 },
        { title: '商品通用名', key: 'approvedName', minWidth: 116 },
        { title: '批准文号/注册证号', key: 'approvalCode', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '生产企业', key: 'producer', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '最后更新人', key: 'createUserName', minWidth: 116 },
        { title: '最后更新时间', key: 'createTimeStr', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => (this.hasEditable ? h('lk-button', {
            props: {
              type: 'text',
              disabled: row.doubtfulCount === 0,
            },
            on: {
              click: () => {
                // this.handleLog(row.id);
                this.handleLog(row.serialCode);
              },
            },
          }, '操作日志') : null),
        },
      ],
      tableData: [],
      logData: [],
    };
  },
  computed: {
    hasEditable() {
      return this.handlePermission('goodsPrimaryKeyOperateLog');
    },
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData(loading) {
		  return new Promise((resolve) => {
        this.params.page = this.page;
        this.params.size = this.size;
        this.$store.commit('setDisableLoading', loading);
        toolsService.getGoodsPrimaryList(this.params).then((res) => {
          if (res.data.status === 200) {
            const { count, list } = res.data.data;
            list.forEach((item) => {
              // const result = {};
              // utils.exchangeTable(item, result);
              item.createTimeStr = utils.formatTime(item.createTime); // 创建时间
            });
            this.count = count;
            this.tableData = list;
			      resolve(list);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
	    });
    },
    addNew() {
      this.$router.push({ name: 'goodsPrimaryKeyAdd' });
    },
    handleLog(serialCode) {
      this.logData = [];
      this.showLog = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.getGoodsPrimaryOperationLogList({ serialCode }).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          const logItem = {
            content: `${utils.formatTime(data.createTime)}由 ${data.createUserName} ${data.contentList.join(';')}`,
          };
          this.logData.push(logItem);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 轮询修改结果
    pollingData() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData(true).then((data) => {
          this.tableData = data;

          // 没有数据或者都是完成状态
          if (data.every(item => item.status === 1)) {
          	clearInterval(this.timer);
          }
        });
      }, 5000);
    },
  },
  created() {
    if (!this.hasEditable) {
      this.columns.pop();
    }
    this.handleSearch(true, this.pollingData);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
  .error {
    color: #ed4014;
  }
</style>
